export default __webpack_public_path__ + "img/02c5146935351b2a2b119c7284e490d2.svg";